

import React from 'react';
import './App.css';
import { Router } from './routes/Router';
import configureStore from './store/Store';
import { Provider } from 'react-redux';
import { SocketProvider } from './components/Utils/SocketProvider';

// helmet for CSP
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { v4 as uuid } from 'uuid';

// emotion
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';


// Generate a unique nonce
const uuidNonce = uuid();
const sha256 = require('crypto-js/sha256');
const nounce = sha256(uuidNonce).toString();


const cache = createCache({
  key: 'css',
  nonce: nounce || '',
});

// Add nonce to all HTML elements
const htmlElements = document.getElementsByTagName('*');
for (let i = 0; i < htmlElements.length; i++) {
  htmlElements[i].setAttribute('nonce', nounce);
}

// Content Security Policy
const csp = `
  default-src 'self' ${process.env.REACT_APP_SOCKET_IO_ENDPOINT};
  connect-src 'self' ${process.env.REACT_APP_SOCKET_IO_ENDPOINT} ws: wss:;
  style-src 'self' 'nonce-${nounce}' https://fonts.googleapis.com;
  script-src 'self';
  font-src 'self' https://fonts.gstatic.com;
  img-src 'self' data: ${process.env.REACT_APP_SOCKET_IO_ENDPOINT};
`;

// const socketIoEndpoint = process.env.REACT_APP_SOCKET_IO_ENDPOINT || 'http://localhost:8081' || 'http://localhost:5000';
// const socketIoDomain = socketIoEndpoint.replace(/^https?:\/\//, ''); // Removes "http://" or "https://"

// const csp = `
//   default-src 'self' ${socketIoDomain};
//   connect-src 'self' ${socketIoDomain} ws://${socketIoDomain} wss://${socketIoDomain} ws: wss:;
//   style-src 'self' 'nonce-${nounce}' https://fonts.googleapis.com;
//   script-src 'self' 'nonce-${nounce}';
//   font-src 'self' https://fonts.gstatic.com;
//   img-src 'self' data: ${socketIoDomain};
// `;


export const App = () => {
  return (
    <Provider store={configureStore()}>
      <HelmetProvider>
        <Helmet>
          <meta http-equiv="Content-Security-Policy" content={csp} />
          <meta property="csp-nonce" content={nounce} />
        </Helmet>
        <CacheProvider value={cache}>
          <SocketProvider>
            <Router />
          </SocketProvider>
        </CacheProvider>
      </HelmetProvider>
    </Provider>
  );
};
